module.exports = __webpack_public_path__ + "img/soundwave.a25522c9.svg";